import { Outlet } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Footer from '../components/Footer';
import IMG from  '../Assets/display.jpg'
function Mainpage() {
  return (
    <div className="App">
        <div className="font-serif text-gray-800 w-screen" >
                  <style jsx>{`
                      .hero-bg {
                      position:relative;
                          background-image: linear-gradient(rgba(75, 73, 73, 0.5), rgba(0, 0, 0, 0.5)), url('${IMG}');
                          background-size: cover;
                          background-position: center;
                          height:50vh;
                      }
                      .gallery-img {
                          transition: transform 0.3s ease;
                      }
                      .gallery-img:hover {
                          transform: scale(1.05);
                      }
                  `}</style>
        <Navbar />

        <Outlet />
        <Footer />
      </div>
    </div>
  );
}

export default Mainpage;